import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=1aa44e19&scoped=true"
import script from "./translate.vue?vue&type=script&lang=js"
export * from "./translate.vue?vue&type=script&lang=js"
import style0 from "./translate.vue?vue&type=style&index=0&id=1aa44e19&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa44e19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa44e19')) {
      api.createRecord('1aa44e19', component.options)
    } else {
      api.reload('1aa44e19', component.options)
    }
    module.hot.accept("./translate.vue?vue&type=template&id=1aa44e19&scoped=true", function () {
      api.rerender('1aa44e19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/technology/TextTranslation/components/translate.vue"
export default component.exports